module.exports = __webpack_public_path__ + "img/262.fd195673.png";